import React, { useEffect, useState } from "react";
import { IContract, IContractLimit } from "dataModels/contract";
import { Input as TextInput, DatePicker, Switch } from "@ds/ds-snam/react";
import { Checkbox } from "@ds/ds-snam/react";
import { /*Container,*/ Row, Col } from "react-grid-system";
import moment from "moment";
import { CalendarMode, SnamPlantKey } from "shared/constants";
import { useTranslation } from "react-i18next";
import { v4 as uuid } from "uuid";
import _ from "lodash";
import { appStore } from "state/appStore";

interface IContractFormDataInputProps {
    formData: IContract,
    onSwitchInputChange: (label: string, switchLabel: string) => void,
    onTextInputChange: (inputEvent: Event) => void,
    onDateInputChange: (inputEvent: Event, fieldName: string) => void,
    onCheckboxChange: (event: Event, value: CalendarMode) => void,
    onContractLimitChange: (event:Event, limitType:CalendarMode)=>void,
    minEndDate?: Date
}
const ContractFormDataInput: React.FC<IContractFormDataInputProps> = (props): JSX.Element => {
    const { t } = useTranslation(['contract']);
    const plantIdValue: string|undefined = appStore.getState().plant.plantId;

    const { formData, onSwitchInputChange, onTextInputChange, onDateInputChange, onCheckboxChange, onContractLimitChange, minEndDate } = props;
    {/*const [localSlot, setLocalSlot] = useState(formData.limits[0]?.slot || 0);
    const [localDelta, setLocalDelta] = useState(formData.limits[0]?.delta || 0);
    
    useEffect(() => {
      // Sync state with formData whenever formData changes
      setLocalSlot(formData.limits[0]?.slot || 0);
      setLocalDelta(formData.limits[0]?.delta || 0);
    }, [formData]);*/}

    

    
    const getInputSwitch = (label: keyof IContract) =>{
        return <>{<Switch
            switchLabelLeft={t('settings.slotParameters.btnLeft')}
            switchLabelRight={t('settings.slotParameters.btnRight')}
            //switchIconLeft="icon-add-circle"
            //switchIconRight="icon-add-circle"
            switchSize="medium"
            checkedButton={formData[label] ? "right" : "left"}
            buttonLeftAriaLabel="Left aria text"
            buttonRightAriaLabel="Right aria text"
            switchLeftId="switchLeftId"
            switchRightId="switchRightId"
            onSwitchChange={(event:Event) => {
                //console.log((event as CustomEvent).detail.switch);
                //console.log(label);
                onSwitchInputChange(label, (event as CustomEvent).detail.switch);
            }}
            style={{float:'right'}}
        ></Switch>}</>
    }

    

    return (
        <>
            <Row>
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                        <TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.0')+'*'}//"Codice contratto"
                            inputValue={formData.code}
                            inputName="code"
                            inputId="code"
                            inputDescription=""
                            inputStatus="default"
                            inputPlaceholder=""
                            isDisabled={false}
                            input-event-type="single_character"
                            isNumberVariant={false}
                            incrementButtonAriaLabel="increment aria text"
                            decrementButtonAriaLabel="decrement aria text"
                            isReadonly={false}
                            onInputChange={onTextInputChange}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                        <DatePicker
                            id="startDate"
                            datePickerTitle={t('contract.contractForm.sections.dataInput.fields.1') + " *"}//"Data inizio validità"
                            isRangePicker={false}
                            datePickerVariant="full-date"
                            datePickerPlaceholder=""
                            startingYear={1990}
                            endingYear={2099}
                            defaultDate={moment.unix(formData.startDate).toDate()}
                            isDisabled={false}
                            datePickerStatus="default"
                            confirmButtonLabel="Conferma"
                            hasCloseButton={false}
                            zIndex={999}
                            isReadonly={false}
                            onDateSelection={(event: Event) => {
                                onDateInputChange(event, 'startDate')
                            }}
                        ></DatePicker>
                    </div>
                </Col>
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                        <DatePicker
                            id="endDate"
                            datePickerTitle={t('contract.contractForm.sections.dataInput.fields.2') + " *"}//"Data fine validità"
                            isRangePicker={false}
                            datePickerVariant="full-date"
                            datePickerPlaceholder=""
                            startingYear={new Date().getFullYear()}
                            endingYear={2099}
                            defaultDate={moment.unix(formData.endDate).toDate()}
                            disabledDates={{ lastDisabledDate: minEndDate }}
                            isDisabled={false}
                            datePickerStatus="default"
                            confirmButtonLabel="Conferma"
                            hasCloseButton={false}
                            zIndex={999}
                            isReadonly={false}
                            onDateSelection={(event: Event) => {
                                onDateInputChange(event, 'endDate')
                            }}
                        ></DatePicker>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                        <TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.3') + " *"}//"Indica gli slot contrattuali"
                            inputValue={formData.slot.toString()}
                            inputName="slot"
                            inputId="slot"
                            inputDescription="#"
                            inputStatus="default"
                            inputPlaceholder=""
                            isDisabled={false}
                            input-event-type="single_character"
                            isNumberVariant={true}
                            incrementButtonAriaLabel="increment aria text"
                            decrementButtonAriaLabel="decrement aria text"
                            isReadonly={false}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                        {/*<p className="textInputWrapperDesc">#</p>*/}
                    </div>
                </Col>

                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                        <TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.4') + " *"}//"Percentuale ToP"
                            inputValue={formData.topPercentage.toString()}
                            inputName="topPercentage"
                            inputId="topPercentage"
                            inputDescription="%"
                            inputStatus="default"
                            inputPlaceholder=""
                            isDisabled={false}
                            input-event-type="single_character"
                            isNumberVariant={true}
                            maxValue={100}
                            minValue={0}
                            incrementButtonAriaLabel="increment aria text"
                            decrementButtonAriaLabel="decrement aria text"
                            isReadonly={false}
                            onInputChange={onTextInputChange}
                        />
                        {/*<p className="textInputWrapperDesc">%</p>*/}
                    </div>
                </Col>
            </Row>

            <Row>
                <Col>
                    <div className="new-contract-form--subtitle">
                        {t('contract.contractForm.sections.dataInput.fields.5')}
                    </div>
                </Col>
            </Row>

            {plantIdValue === SnamPlantKey.PIGNATARO && <><Row>
                <Col xs={12} md={5} style={{display:'flex',marginBottom:'20px'}}>    
                    <div style={{flex:'1'}}>
                        <div>
                            <TextInput
                                inputLabel={t('contract.contractForm.sections.dataInput.fields.6') + " *" }//"Tariffa loading"
                                inputValue={formData.rateLoading.toString()}
                                inputName="rateLoading"
                                inputId="rateLoading"
                                inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                                inputStatus="default"
                                inputPlaceholder=""
                                isDisabled={!formData.rateLoadingAvailable} 
                                input-event-type="single_character"
                                isNumberVariant={true}
                                incrementButtonAriaLabel="increment aria text"
                                decrementButtonAriaLabel="decrement aria text"
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                                minValue={0}
                            />
                        </div>
                    </div>                                
                    <div style={{flex:'1',marginLeft:'20px'}}>
                        <TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.6') + " *" + " MWh"}//"Tariffa loading MWH"
                            inputValue={formData.rateLoadingMWh.toString()}
                            inputName="rateLoadingMWh"
                            inputId="rateLoadingMWh"
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.3')}
                            inputStatus="default"
                            inputPlaceholder=""
                            isDisabled={!formData.rateLoadingAvailable}
                            input-event-type="single_character"
                            isNumberVariant={true}
                            incrementButtonAriaLabel="increment aria text"
                            decrementButtonAriaLabel="decrement aria text"
                            isReadonly={false}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                    </div>
                    <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch('rateLoadingAvailable')}</div>

                </Col>
            </Row>  </>}  
            {plantIdValue === SnamPlantKey.PIGNATARO && <><Row>
                <Col xs={12} md={5} style={{display:'flex',marginBottom:'20px'}}>

                    <div style={{flex:'1'}}>
                        <div>
                            <TextInput
                                inputLabel={t('contract.contractForm.sections.dataInput.fields.6') + " last minute *" }//"Tariffa loading last minute"
                                inputValue={formData.rateLoadingLastMinute.toString()}
                                inputName="rateLoadingLastMinute"
                                inputId="rateLoadingLastMinute"
                                inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                                inputStatus="default"
                                inputPlaceholder=""
                                isDisabled={!formData.rateLoadingAvailable} 
                                input-event-type="single_character"
                                isNumberVariant={true}
                                incrementButtonAriaLabel="increment aria text"
                                decrementButtonAriaLabel="decrement aria text"
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                                minValue={0}
                            />
                        </div>
                    </div>
                    <div style={{flex:'1',marginLeft:'20px'}}>
                        <div>
                            <TextInput
                                inputLabel={t('contract.contractForm.sections.dataInput.fields.6') + " last minute MWh*"}//"Tariffa loading last minute"
                                inputValue={formData.rateLoadingLastMinuteMWh.toString()}
                                inputName="rateLoadingLastMinuteMWh"
                                inputId="rateLoadingLastMinuteMWh"
                                inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.3')}
                                inputStatus="default"
                                inputPlaceholder=""
                                isDisabled={!formData.rateLoadingAvailable} 
                                input-event-type="single_character"
                                isNumberVariant={true}
                                incrementButtonAriaLabel="increment aria text"
                                decrementButtonAriaLabel="decrement aria text"
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                                minValue={0}
                            />
                        </div>
                    </div>                    
                    <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch('rateLoadingAvailable')}</div>

                </Col>
                <Col xs={12} md={5} style={{display:'flex',marginBottom:'20px'}}>
                    {/* <div style={{flex:'1'}}>
                    <div><TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.7')}//"Extra Tariff - BioLNG loading"
                            inputValue={formData.rateLoadingBio.toString()}
                            inputName="rateLoadingBio"
                            inputId="rateLoadingBio"
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                            inputStatus="default"
                            input-event-type="single_character"
                            isNumberVariant={true}
                            isDisabled={!formData.rateLoadingBioAvailable }
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                        </div>
                    </div> */}
                    <div style={{flex:'1'}}>
                        <TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.7') /*+ " MWh"*/}//""
                            inputValue={formData.rateLoadingBioMWh.toString()}
                            inputName="rateLoadingBioMWh"
                            inputId="rateLoadingBioMWh"
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.3')}
                            inputStatus="default"
                            input-event-type="single_character"
                            isNumberVariant={true}
                            isDisabled={!formData.rateLoadingBioAvailable }
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                    </div>
                    <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch('rateLoadingBioAvailable')}</div>

                </Col>
            </Row></>}             
            {plantIdValue === SnamPlantKey.PANIGAGLIA && <><Row>
                <Col xs={12} md={5} style={{display:'flex',marginBottom:'20px'}}>
                    <div style={{flex:'1'}}>
                        <div>
                            <TextInput
                                inputLabel={t('contract.contractForm.sections.dataInput.fields.6') + " *" }//"Tariffa loading"
                                inputValue={formData.rateLoading.toString()}
                                inputName="rateLoading"
                                inputId="rateLoading"
                                inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                                inputStatus="default"
                                inputPlaceholder=""
                                isDisabled={!formData.rateLoadingAvailable} 
                                input-event-type="single_character"
                                isNumberVariant={true}
                                incrementButtonAriaLabel="increment aria text"
                                decrementButtonAriaLabel="decrement aria text"
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                                minValue={0}
                            />
                        </div>
                    </div>
                    <div style={{flex:'1',marginLeft:'20px'}}>
                        <div>
                            <TextInput
                                inputLabel={t('contract.contractForm.sections.dataInput.fields.6') + " last minute *" }//"Tariffa loading last minute"
                                inputValue={formData.rateLoadingLastMinute.toString()}
                                inputName="rateLoadingLastMinute"
                                inputId="rateLoadingLastMinute"
                                inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                                inputStatus="default"
                                inputPlaceholder=""
                                isDisabled={false} 
                                input-event-type="single_character"
                                isNumberVariant={true}
                                incrementButtonAriaLabel="increment aria text"
                                decrementButtonAriaLabel="decrement aria text"
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                                minValue={0}
                            />
                        </div>
                    </div>
                    <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch('rateLoadingAvailable')}</div>

                </Col>
                <Col xs={12} md={5} style={{display:'flex',marginBottom:'20px'}}>
                    {/* <div style={{flex:'1'}}>
                    <div><TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.7')}//"Extra Tariff - BioLNG loading"
                            inputValue={formData.rateLoadingBio.toString()}
                            inputName="rateLoadingBio"
                            inputId="rateLoadingBio"
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                            inputStatus="default"
                            input-event-type="single_character"
                            isNumberVariant={true}
                            isDisabled={!formData.rateLoadingBioAvailable }
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                        </div>
                    </div> */}
                    <div style={{flex:'1'}}>
                        <TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.7') /*+ " MWh"*/}//"Extra Tariff - BioLNG loading"
                            inputValue={formData.rateLoadingBioMWh.toString()}
                            inputName="rateLoadingBioMWh"
                            inputId="rateLoadingBioMWh"
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.3')}
                            inputStatus="default"
                            input-event-type="single_character"
                            isNumberVariant={true}
                            isDisabled={!formData.rateLoadingBioAvailable }
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                    </div>
                    <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch('rateLoadingBioAvailable')}</div>

                </Col>
            </Row></>} 

            <Row>
                <Col xs={12} md={5} style={{display:'flex',marginBottom:'20px'}}>
                    <div style={{flex:'1'}}>
                    <div><TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.8')}//"Tariffa Cool down"
                            inputValue={formData.rateCoolDown.toString()}
                            inputName="rateCoolDown"
                            inputId="rateCoolDown"
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                            inputStatus="default"
                            input-event-type="single_character"
                            isNumberVariant={true}
                            isDisabled={!formData.rateCoolDownAvailable}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                        {/*<p className="textInputWrapperDesc">{t('contract.contractForm.sections.dataInput.fieldDesc.0')}</p>*/}</div>
                    </div>
                    {plantIdValue===SnamPlantKey.PIGNATARO && <div style={{flex:'1',marginLeft:'20px'}}>
                        <TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.8') + " MWh"}//"Tariffa Cool down"
                            inputValue={formData.rateCoolDownMWh.toString()}
                            inputName="rateCoolDownMWh"
                            inputId="rateCoolDownMWh"
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.3')}
                            inputStatus="default"
                            input-event-type="single_character"
                            isNumberVariant={true}
                            isDisabled={!formData.rateCoolDownAvailable}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                    </div>}
                    <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch('rateCoolDownAvailable')}</div>

                </Col>
                <Col xs={12} md={5} style={{display:'flex',marginBottom:'20px'}}>
                    <div style={{flex:'1'}}>
                    <div><TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.9')}//"Tariffa Extra - Gas up"
                            inputValue={formData.rateGasUp.toString()}
                            inputName="rateGasUp"
                            inputId="rateGasUp"
                            inputStatus="default"
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                            input-event-type="single_character"
                            isNumberVariant={true}
                            isReadonly={false}
                            isDisabled={!formData.rateGasUpAvailable}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                        {/*<p className="textInputWrapperDesc">{t('contract.contractForm.sections.dataInput.fieldDesc.0')}</p>*/}</div>
                        
                    </div>
                    {plantIdValue===SnamPlantKey.PIGNATARO && <div style={{flex:'1',marginLeft:'20px'}}>
                        <TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.9') + " MWh"}//"Tariffa Extra - Gas up"
                            inputValue={formData.rateGasUpMWh.toString()}
                            inputName="rateGasUpMWh"
                            inputId="rateGasUpMWh"
                            inputStatus="default"
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.3')}
                            input-event-type="single_character"
                            isNumberVariant={true}
                            isReadonly={false}
                            isDisabled={!formData.rateGasUpAvailable}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                    </div>}
                    <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch('rateGasUpAvailable')}</div>
                </Col>
            </Row>

            <Row>
                <Col xs={12} md={5} style={{display:'flex',marginBottom:'20px'}}>
                    <div style={{flex:'1'}}>
                    <div><TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.10')}//"Semi - trailer approval"
                            inputValue={formData.rateSemiTrailerApproval.toString()}
                            inputName="rateSemiTrailerApproval"
                            inputId="rateSemiTrailerApproval"
                            inputStatus="default"
                            input-event-type="single_character"
                            isNumberVariant={true}
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                            isReadonly={false}
                            isDisabled={!formData.rateSemiTrailerApprovalAvailable}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                        {/*<p className="textInputWrapperDesc">{t('contract.contractForm.sections.dataInput.fieldDesc.0')}</p>*/}</div>

                    </div>
                    {plantIdValue===SnamPlantKey.PIGNATARO && <div style={{flex:'1',marginLeft:'20px'}}>
                        <TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.10') + " MWh"}//"Semi - trailer approval"
                            inputValue={formData.rateSemiTrailerApprovalMWh.toString()}
                            inputName="rateSemiTrailerApprovalMWh"
                            inputId="rateSemiTrailerApprovalMWh"
                            inputStatus="default"
                            input-event-type="single_character"
                            isNumberVariant={true}
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.3')}
                            isReadonly={false}
                            isDisabled={!formData.rateSemiTrailerApprovalAvailable}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                    </div>}
                    <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch('rateSemiTrailerApprovalAvailable')}</div>

                </Col>
                <Col xs={12} md={5} style={{display:'flex',marginBottom:'20px'}}>
                    <div style={{flex:'1'}}>
                    <div><TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.11')}//"Driver approval"
                            inputValue={formData.rateDriverApproval.toString()}
                            inputName="rateDriverApproval"
                            inputId="rateDriverApproval"
                            inputStatus="default"
                            input-event-type="single_character"
                            isNumberVariant={true}
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                            isDisabled={!formData.rateDriverApprovalAvailable}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                        {/*<p className="textInputWrapperDesc">{t('contract.contractForm.sections.dataInput.fieldDesc.0')}</p>*/}</div>
                    </div>
                    {plantIdValue===SnamPlantKey.PIGNATARO && <div style={{flex:'1',marginLeft:'20px'}}>
                        <TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.11') + " MWh"}//"Driver approval"
                            inputValue={formData.rateDriverApprovalMWh.toString()}
                            inputName="rateDriverApprovalMWh"
                            inputId="rateDriverApprovalMWh"
                            inputStatus="default"
                            input-event-type="single_character"
                            isNumberVariant={true}
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.3')}
                            isDisabled={!formData.rateDriverApprovalAvailable}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                    </div>}
                    <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch('rateDriverApprovalAvailable')}</div>

                </Col>
            </Row>

            <Row>
                <Col xs={12} md={5} style={{display:'flex',marginBottom:'20px'}}>
                    <div style={{flex:'1'}}>
                    <div><TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.12')}//"Semi - Trailer + Driver approval"
                            inputValue={formData.rateSemiTrailerAndDriverApproval.toString()}
                            inputName="rateSemiTrailerAndDriverApproval"
                            inputId="rateSemiTrailerAndDriverApproval"
                            inputStatus="default"
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                            input-event-type="single_character"
                            isNumberVariant={true}
                            isReadonly={false}
                            isDisabled={!formData.rateSemiTrailerAndDriverApprovalAvailable}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                        {/*<p className="textInputWrapperDesc">{t('contract.contractForm.sections.dataInput.fieldDesc.0')}</p>*/}</div>
                    </div>
                    {plantIdValue===SnamPlantKey.PIGNATARO && <div style={{flex:'1',marginLeft:'20px'}}>
                        <TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.12') + " MWh"}//"Semi - Trailer + Driver approval"
                            inputValue={formData.rateSemiTrailerAndDriverApprovalMWh.toString()}
                            inputName="rateSemiTrailerAndDriverApprovalMWh"
                            inputId="rateSemiTrailerAndDriverApprovalMWh"
                            inputStatus="default"
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.3')}
                            input-event-type="single_character"
                            isNumberVariant={true}
                            isReadonly={false}
                            isDisabled={!formData.rateSemiTrailerAndDriverApprovalAvailable}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                    </div>}
                    <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch('rateSemiTrailerAndDriverApprovalAvailable')}</div>

                </Col>
                <Col xs={12} md={5} style={{display:'flex',marginBottom:'20px'}}>
                    <div style={{flex:'1'}}>
                    <div><TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.13')}//"ISO Container approval"
                            inputValue={formData.rateIsoContainerApproval.toString()}
                            inputName="rateIsoContainerApproval"
                            inputId="rateIsoContainerApproval"
                            inputStatus="default"
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                            input-event-type="single_character"
                            isNumberVariant={true}
                            isReadonly={false}
                            isDisabled={!formData.rateIsoContainerApprovalAvailable}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                        {/*<p className="textInputWrapperDesc">{t('contract.contractForm.sections.dataInput.fieldDesc.0')}</p>*/}</div>
                    </div>
                    {plantIdValue===SnamPlantKey.PIGNATARO && <div style={{flex:'1',marginLeft:'20px'}}>
                        <TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.13') + " MWh"}//"ISO Container approval"
                            inputValue={formData.rateIsoContainerApprovalMWh.toString()}
                            inputName="rateIsoContainerApprovalMWh"
                            inputId="rateIsoContainerApprovalMWh"
                            inputStatus="default"
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.3')}
                            input-event-type="single_character"
                            isNumberVariant={true}
                            isReadonly={false}
                            isDisabled={!formData.rateIsoContainerApprovalAvailable}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                    </div>}
                    <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch('rateIsoContainerApprovalAvailable')}</div>

                </Col>
            </Row>

            <Row>
                <Col xs={12} md={5} style={{display:'flex',marginBottom:'20px'}}>
                    <div style={{flex:'1'}}>
                    <div><TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.14')}//"ISO Container Approval + Driver approval"
                            inputValue={formData.rateIsoContainerAndDriverApproval.toString()}
                            inputName="rateIsoContainerAndDriverApproval"
                            inputId="rateIsoContainerAndDriverApproval"
                            inputStatus="default"
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                            input-event-type="single_character"
                            isNumberVariant={true}
                            isReadonly={false}
                            isDisabled={!formData.rateIsoContainerAndDriverApprovalAvailable}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                        {/*<p className="textInputWrapperDesc">{t('contract.contractForm.sections.dataInput.fieldDesc.0')}</p>*/}</div>
                    </div>
                    {plantIdValue===SnamPlantKey.PIGNATARO && <div style={{flex:'1',marginLeft:'20px'}}>
                        <TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.14') + " MWh"}//"ISO Container Approval + Driver approval"
                            inputValue={formData.rateIsoContainerAndDriverApprovalMWh.toString()}
                            inputName="rateIsoContainerAndDriverApprovalMWh"
                            inputId="rateIsoContainerAndDriverApprovalMWh"
                            inputStatus="default"
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.3')}
                            input-event-type="single_character"
                            isNumberVariant={true}
                            isReadonly={false}
                            isDisabled={!formData.rateIsoContainerAndDriverApprovalAvailable}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                    </div>}
                    <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch('rateIsoContainerAndDriverApprovalAvailable')}</div>

                </Col>
                <Col xs={12} md={5} style={{display:'flex',marginBottom:'20px'}}>
                    <div style={{flex:'1'}}>
                    <div><TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.15')}//"Tariffa Truck tractor approval"
                            inputValue={formData.rateTruckTractorApproval.toString()}
                            inputName="rateTruckTractorApproval"
                            inputId="rateTruckTractorApproval"
                            inputStatus="default"
                            input-event-type="single_character"
                            isNumberVariant={true}
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.1')}
                            isDisabled={!formData.rateTruckTractorApprovalAvailable}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                        {/*<p className="textInputWrapperDesc">{t('contract.contractForm.sections.dataInput.fieldDesc.1')}</p>*/}</div>
                    </div>
                    <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch('rateTruckTractorApprovalAvailable')}</div>

                </Col>
            </Row>

            <Row>
                <Col xs={12} md={5} style={{display:'flex',marginBottom:'20px'}}>
                    <div style={{flex:'1'}}>
                        <div><TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.16')}//"Tariffa Container platform approval"
                            inputValue={formData.rateContainerPlatformApproval.toString()}
                            inputName="rateContainerPlatformApproval"
                            inputId="rateContainerPlatformApproval"
                            inputStatus="default"
                            input-event-type="single_character"
                            isNumberVariant={true}
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.1')}
                            isDisabled={!formData.rateContainerPlatformApprovalAvailable}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                        {/*<p className="textInputWrapperDesc">{t('contract.contractForm.sections.dataInput.fieldDesc.1')}</p>*/}</div>
                    </div>
                    <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch('rateContainerPlatformApprovalAvailable')}</div>
                </Col>
                

            </Row>
            <Row>
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                        <TextInput
                            inputLabel={t('contract.contractForm.sections.dataInput.fields.17')}//"Multa Failure to Take"
                            inputValue={formData.fineFailureTake.toString()}
                            inputName="fineFailureTake"
                            inputId="fineFailureTake"
                            inputStatus="default"
                            input-event-type="single_character"
                            isNumberVariant={true}
                            isReadonly={false}
                            inputDescription={t('contract.contractForm.sections.dataInput.fieldDesc.2')}
                            onInputChange={onTextInputChange}
                            minValue={0}
                        />
                        {/*<p className="textInputWrapperDesc">{t('contract.contractForm.sections.dataInput.fieldDesc.2')}</p>*/}
                    </div>
                </Col>
            </Row>

            {/** Contract limits */}
            <Row>
                <Col>
                    <div className="new-contract-form--subtitle">
                        {/*Limiti contrattuali*/}
                        {t('contract.contractForm.sections.dataInput.contractLimits.title')}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                        <DatePicker
                            id="contractLimitDate"
                            datePickerTitle={t('contract.contractForm.sections.dataInput.fields.18') + " *"}//"Data inizio validità"
                            isRangePicker={false}
                            datePickerVariant="full-date"
                            datePickerPlaceholder=""
                            startingYear={1990}
                            endingYear={2099}
                            defaultDate={moment.unix(formData.contractLimitDate ?? formData.startDate).toDate()}
                            isDisabled={false}
                            datePickerStatus="default"
                            confirmButtonLabel="Conferma"
                            hasCloseButton={false}
                            zIndex={999}
                            isReadonly={false}
                            onDateSelection={(event: Event) => {
                                onDateInputChange(event, 'contractLimitDate')
                            }}
                        ></DatePicker>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="textInputWrapper" style={{ display: "flex", gap: "20px" }}>
                        {
                            Object.values(CalendarMode)
                                .filter((calMode) => !isNaN(Number(calMode)))
                                .map((calMode) => {
                                    const foundLimit = _.find(formData.limits, function (limit) { return limit.type === calMode; });
                                    return <Checkbox
                                        key={uuid()}
                                        checkboxStatus="default"
                                        checkboxLabel={t("contract.contractForm.sections.dataInput.contractLimits.selectionTiming." + calMode)}
                                        isChecked={foundLimit !== undefined}
                                        onCheckboxChange={(event: Event) => {
                                            onCheckboxChange(event, calMode as CalendarMode);
                                        }}>
                                    </Checkbox>
                                })
                        }



                    </div>
                </Col>
            </Row>

            {formData.limits.length ?_.orderBy(formData.limits, ['type'], ['asc']).map((limit: IContractLimit) => {
                return (
                    <Row key={limit.type} > {/*key={uuid()}*/}
                        <Col xs={12} md={4}>
                            <div className="textInputWrapper">
                                <TextInput
                                    inputLabel={t('contract.contractForm.sections.dataInput.contractLimits.fields.slot.' + limit.type)}//"numero slot"
                                    inputValue={limit.slot.toString()}
                                    inputName="slot"
                                    inputId="slot"
                                    inputStatus="default"
                                    input-event-type="single_character"
                                    isNumberVariant={true}
                                    minValue={0}
                                    inputDescription="#"
                                    onInputChange={(event:Event) => {
                                        onContractLimitChange(event, limit.type)
                                    }}
                                />
                                {/*<p className="textInputWrapperDesc">#</p>*/}
                            </div>
                        </Col>
                        
                        <Col xs={12} md={4}>
                            <div className="textInputWrapper">
                                <TextInput
                                    inputLabel={t('contract.contractForm.sections.dataInput.contractLimits.fields.delta.' + limit.type)}//"percentuale scostamento"
                                    inputValue={limit.delta.toString()}
                                    inputName="delta"
                                    inputId="delta"
                                    inputStatus="default"
                                    input-event-type="single_character"
                                    isNumberVariant={true}
                                    minValue={0}
                                    inputDescription="%"
                                    onInputChange={(event:Event) => {
                                        onContractLimitChange(event, limit.type)
                                    }}
                                />
                                {/*<p className="textInputWrapperDesc">%</p>*/}
                            </div>
                        </Col>
                    </Row>
                )
            }):<></>}
            {/*formData.limits[0] ?
                    <Row>
                        <Col xs={12} md={4}>
                            <div className="textInputWrapper">
                                <TextInput
                                    inputLabel={t('contract.contractForm.sections.dataInput.contractLimits.fields.slot.' + formData.limits[0].type)}//"Multa Failure to Take"
                                    inputValue={localSlot.toString()}
                                    inputName="slot"
                                    inputId="slot"
                                    inputStatus="default"
                                    input-event-type="single_character"
                                    isNumberVariant={true}
                                    onInputChange={(event:Event) => {
                                        setLocalSlot(Number((event as CustomEvent).detail.input.value));
                                        onContractLimitChange(event, formData.limits[0].type)
                                    }}
                                />
                            </div>
                        </Col>
                        
                        <Col xs={12} md={4}>
                            <div className="textInputWrapper">
                                <TextInput
                                    inputLabel={t('contract.contractForm.sections.dataInput.contractLimits.fields.delta.' + formData.limits[0].type)}//"Multa Failure to Take"
                                    inputValue={localDelta.toString()}
                                    inputName="delta"
                                    inputId="delta"
                                    inputStatus="default"
                                    input-event-type="single_character"
                                    isNumberVariant={true}
                                    onInputChange={(event:Event) => {
                                        setLocalDelta(Number((event as CustomEvent).detail.input.value));
                                        onContractLimitChange(event, formData.limits[0].type)
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
            :<></>*/}
            
        </>
    );
}
export default ContractFormDataInput;